module.exports = __webpack_public_path__ + "media/images/gallery/aurorae/2001-11-05/19-66032ff625e18bcfbddc68637d65cce2.jpg";